var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.noBack),expression:"!noBack"}],staticClass:"back",on:{"click":_vm.back}},[_c('van-icon',{attrs:{"name":"arrow-left"}}),_c('div',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }